import React, { useState } from 'react';
import './Login.css';
import { validateUser } from '../config/users';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const user = validateUser(username, password);
    
    if (user) {
      onLogin(user);
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('username', user.username);
      localStorage.setItem('userRole', user.role);
    } else {
      setError('用户名或密码错误');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <img src="/assets/logo.png" alt="Logo" className="login-logo" />
          <h1>人才盘点系统</h1>
        </div>
        <form onSubmit={handleSubmit}>
          {error && <div className="error-message">{error}</div>}
          <div className="form-group">
            <label>用户名</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              placeholder="请输入用户名"
            />
          </div>
          <div className="form-group">
            <label>密码</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="请输入密码"
            />
          </div>
          <button type="submit" className="login-button">登录</button>
        </form>
        <div className="login-footer">
          <p>请联系管理员获取登录账号</p>
        </div>
      </div>
    </div>
  );
};

export default Login; 